export function saveCurrentUrl(currentUrl: string) {
  sessionStorage.setItem('redirectPath', currentUrl);
}

export function getRedirectPath() {
  return sessionStorage.getItem('redirectPath') ?? null;
}
